<template>
  <div id="app">
    <ValidateDomain v-if="!isValidDomain" />
    <GlobalSystemLoader
      :visible="system_loader_visible"
      :message="system_loader_message"
    />
    <router-view/>
  </div>
</template>


<script>
import { onBeforeMount, onBeforeUnmount, ref } from 'vue';
import ValidateDomain from "@/components/config_components/ValidateDomain/ValidateDomain.vue";
import GlobalSystemLoader from "@/components/config_components/GlobalSystemLoader/GlobalSystemLoader.vue";

const default_system_loader_message = 'Loading...';
export default {
  props: {
    isValidDomain: {
      type: Boolean,
      required: true,
    },
  },
  components: { GlobalSystemLoader, ValidateDomain },
  setup() {
    const system_loader_visible = ref(false);
    const system_loader_message = ref(default_system_loader_message);
    const default_loader_message = ref('');
    const sidebar_loader_message = ref('');
    const get_system_loader_message = function get_system_loader_message(event) {
      if (!(event instanceof CustomEvent)) return default_system_loader_message;
      if (typeof event.detail === 'string') return String(event.detail);
      return default_system_loader_message;
    };
    const sync_system_loader = function sync_system_loader() {
      const has_sidebar_message = sidebar_loader_message.value.length > 0;
      const has_default_message = default_loader_message.value.length > 0;
      let latest_message = default_system_loader_message;
      if (has_default_message) latest_message = default_loader_message.value;
      if (has_sidebar_message) latest_message = sidebar_loader_message.value;
      system_loader_visible.value = has_sidebar_message || has_default_message;
      system_loader_message.value = latest_message;
    };
    /** @type {EventListener} */
    const show_system_loader_listener = function show_system_loader_listener(event) {
      default_loader_message.value = get_system_loader_message(event);
      sync_system_loader();
    };
    /** @type {EventListener} */
    const show_sidebar_system_loader_listener = function show_sidebar_system_loader_listener(event) {
      sidebar_loader_message.value = get_system_loader_message(event);
      sync_system_loader();
    };
    /** @type {EventListener} */
    const hide_system_loader_listener = function hide_system_loader_listener() {
      default_loader_message.value = '';
      sync_system_loader();
    };
    /** @type {EventListener} */
    const hide_sidebar_system_loader_listener = function hide_sidebar_system_loader_listener() {
      sidebar_loader_message.value = '';
      sync_system_loader();
    };

    onBeforeMount(() => {
      window.addEventListener('system-loader:show', show_system_loader_listener);
      window.addEventListener('system-loader:hide', hide_system_loader_listener);
      window.addEventListener('system-loader:show:onboarding-sidebar', show_sidebar_system_loader_listener);
      window.addEventListener('system-loader:hide:onboarding-sidebar', hide_sidebar_system_loader_listener);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('system-loader:show', show_system_loader_listener);
      window.removeEventListener('system-loader:hide', hide_system_loader_listener);
      window.removeEventListener('system-loader:show:onboarding-sidebar', show_sidebar_system_loader_listener);
      window.removeEventListener('system-loader:hide:onboarding-sidebar', hide_sidebar_system_loader_listener);
    });

    return {
      system_loader_message,
      system_loader_visible
    };
  }
};
</script>
